import { type LocationTo } from '@framework/ui/core/router/TypedRoute.tsx';
import * as React from 'react';

/**
 * Genera il link di navigazione verso un modulo della richiesta.
 * Restituisce `undefined` quando la navigazione non è disponibile.
 */
export type GetSummaryModuleLink = (
  submissionId: string,
  moduleId: string,
) => LocationTo | undefined;

/**
 * Context per rendere la navigazione al modulo route-agnostica.
 *
 * Il riepilogo è condiviso tra Frontoffice e Backoffice, ma le due app hanno
 * rotte esclusive: ogni app fornisce il proprio generatore di link tramite il
 * provider. In assenza di provider il context è `null` e il bottone "Vai al
 * modulo" viene disabilitato (entrambe le app montano sempre il provider).
 */
export const SummaryModuleLinkContext =
  React.createContext<GetSummaryModuleLink | null>(null);

export const useSummaryModuleLink = () =>
  React.useContext(SummaryModuleLinkContext);

export function SummaryModuleLinkProvider(
  props: React.PropsWithChildren<{ getModuleLink: GetSummaryModuleLink }>,
) {
  const { getModuleLink, children } = props;
  return (
    <SummaryModuleLinkContext.Provider value={getModuleLink}>
      {children}
    </SummaryModuleLinkContext.Provider>
  );
}
